module.exports = __webpack_public_path__ + "static/media/19.3a0caeb6.JPG";